export default {
  baseStyle: {
    popper: {
      zIndex: 20,
    },
  },
};
